// Project 1
export const project1 = {
    id: 1,
    title: "CloudBOT",
    description: "Industry-leading automated trading platform enabling seamless buying and selling of Team Fortress 2 keys for cryptocurrency. CloudBOT facilitates bidirectional trading—instantly convert TF2 keys to crypto or purchase keys with cryptocurrency—through sophisticated exchange API integrations. With over $620,000 in revenue generated and fully automated trading operations, CloudBOT stands as the premier solution in its market, trusted by hundreds of users for secure, efficient digital asset trading.",
    website: "https://cloudtf2.com/",
    images: [
        "/Project-CloudBOT/cloudbot.png",
        "/Project-CloudBOT/cloudbot1.png",
        "/Project-CloudBOT/cloudbot2.png",
        "/Project-CloudBOT/cloudbot3.png",
    ],
};
